<template>
    <section>
        <form-1 ref="form1" @finish="nextState_1 = $event" />
        <form-2 ref="form2" @finish="nextState_2 = $event" />
        <form-4 ref="form4" @finish="nextState_4 = $event" />
    </section>
</template>

<script>
import Form1 from "./Form1.vue";
import Form2 from "./Form2.vue";
import Form4 from "./Form4.vue";

export default {
    components: { Form1, Form2, Form4 },
    data() {
        return {
            nextState_1: false,
            nextState_2: false,
            nextState_4: false,
        };
    },
    methods: {
        allowNext() {
            let form1 = this.$refs.form1.allowNext();
            if (!form1) {
                this.$refs.form1.showAllError();
                this.$buefy.toast.open({
                    message: this.$t("Please add correct address"),
                    type: "is-danger",
                });
                window.scrollTo(0, 200);
                return false;
            }

            let form4 = this.$refs.form4.allowNext();
            if (!form4 || !this.nextState_4) {
                this.$refs.form4.showAllError();
                this.$buefy.toast.open({
                    message: this.$t("Please fill content description"),
                    type: "is-danger",
                });
                return false;
            }

            let form2 = this.$refs.form2.allowNext();
            if (!form2) {
                this.$refs.form2.showAllError();
                this.$buefy.toast.open({
                    message: this.$t("Please fill all wrong data in packages"),
                    type: "is-danger",
                });
                window.scrollTo(0, 500);
                return false;
            }

            return true;
        },

        hideForm() {
            this.$refs.form1.hideForm();
            this.$refs.form2.hideForm();
            this.$refs.form4.hideForm();
        },
    },
};
</script>
